

/** @type {Set<string>} 销项管理列表tableId */
export const TableLabelKeys: Map<string, string> = new Map();

TableLabelKeys.set('saleDraftInvoice','saleDraftInvoice');
TableLabelKeys.set('saleInvoiced','saleInvoiced');
TableLabelKeys.set('saleCollect','saleCollect');
TableLabelKeys.set('redInvoice','redLinkInvoice');
TableLabelKeys.set('applyForm','applyForm');


export default {
    TableLabelKeys
};


// WEBPACK FOOTER //
// ./src/utils/Doc/Table.ts